module.exports = __webpack_public_path__ + "img/UI_shouji_buttonA_02_ec7ddcb36.png";